import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
export function RSVPForm() {
  const navigate = useNavigate();
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    attendees: '1'
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('RSVP submitted:', formData);
    // Show success state
    setIsSubmitted(true);
    // Redirect after 3 seconds
    setTimeout(() => {
      navigate('/');
    }, 3000);
  };
  const isFormValid = formData.name && formData.company && formData.attendees;
  return <div className="min-h-screen bg-gradient-to-br from-navy via-navy-light to-navy flex flex-col relative overflow-hidden" data-id="element-1330">
      {/* Confetti Animation */}
      {isSubmitted && <div className="fixed inset-0 pointer-events-none z-50" data-id="element-1331">
          {[...Array(50)].map((_, i) => <div key={i} className="absolute animate-confetti" style={{
        left: `${Math.random() * 100}%`,
        top: '-10px',
        width: '10px',
        height: '10px',
        backgroundColor: ['#F59E0B', '#FFFFFF', '#3B82F6', '#10B981'][Math.floor(Math.random() * 4)],
        animationDelay: `${Math.random() * 0.5}s`,
        animationDuration: `${2 + Math.random() * 2}s`,
        transform: `rotate(${Math.random() * 360}deg)`
      }} data-id="element-1332" />)}
        </div>}

      <div className="flex-1 flex items-center justify-center px-4 py-6 md:py-8" data-id="element-1333">
        <div className="max-w-2xl w-full" data-id="element-1334">
          <div className="flex justify-center mb-8" data-id="element-1335">
            <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-8 md:h-10 cursor-pointer" onClick={() => navigate('/')} data-id="element-1336" />
          </div>

          {!isSubmitted ? <>
              <div className="text-center mb-6 md:mb-8" data-id="element-1337">
                <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4" data-id="element-1338">
                  RSVP to the Recruiting Breakout Session
                </h2>
                <p className="text-base md:text-lg text-blue-100" data-id="element-1339">
                  Wednesday at 3pm • 45-minute in-depth breakdown
                </p>
              </div>

              <form onSubmit={handleSubmit} data-id="element-1340">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg border-2 border-white/20 p-4 md:p-6 mb-6" data-id="element-1341">
                  <div className="space-y-3 md:space-y-4" data-id="element-1342">
                    <div data-id="element-1343">
                      <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-1344">
                        Your Name
                      </label>
                      <input type="text" name="name" autoComplete="name" value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} placeholder="John Smith" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-1345" />
                    </div>

                    <div data-id="element-1346">
                      <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-1347">
                        Company Name
                      </label>
                      <input type="text" name="organization" autoComplete="organization" value={formData.company} onChange={e => setFormData({
                    ...formData,
                    company: e.target.value
                  })} placeholder="Your Company" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-1348" />
                    </div>

                    <div data-id="element-1349">
                      <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-1350">
                        How Many Are Attending?
                      </label>
                      <select value={formData.attendees} onChange={e => setFormData({
                    ...formData,
                    attendees: e.target.value
                  })} className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-1351">
                        <option value="1" className="bg-navy" data-id="element-1352">
                          1 person
                        </option>
                        <option value="2" className="bg-navy" data-id="element-1353">
                          2 people
                        </option>
                        <option value="3" className="bg-navy" data-id="element-1354">
                          3 people
                        </option>
                        <option value="4" className="bg-navy" data-id="element-1355">
                          4 people
                        </option>
                        <option value="5" className="bg-navy" data-id="element-1356">
                          5 people
                        </option>
                        <option value="6+" className="bg-navy" data-id="element-1357">
                          6+ people
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <button type="submit" disabled={!isFormValid} className="w-full py-4 md:py-5 bg-amber hover:bg-amber-dark disabled:bg-amber/50 disabled:cursor-not-allowed text-navy font-bold text-lg md:text-xl rounded-lg transition-all shadow-xl hover:scale-105 active:scale-100 disabled:hover:scale-100" data-id="element-1358">
                  Confirm RSVP →
                </button>

                <button type="button" onClick={() => navigate('/')} className="w-full mt-4 py-3 text-blue-200 hover:text-white font-semibold transition-colors" data-id="element-1359">
                  ← Back to Home
                </button>
              </form>
            </> : <div className="text-center py-12 animate-fade-in" data-id="element-1360">
              <div className="mb-8" data-id="element-1361">
                <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 bg-green-500 rounded-full flex items-center justify-center animate-scale-in" data-id="element-1362">
                  <svg className="w-10 h-10 md:w-12 md:h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1363">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-1364" />
                  </svg>
                </div>
                <h2 className="text-2xl md:text-4xl font-bold text-white mb-3" data-id="element-1365">
                  You're All Set!
                </h2>
                <p className="text-base md:text-lg text-blue-100 mb-8" data-id="element-1366">
                  We'll see you Wednesday at 3pm
                </p>
              </div>

              <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 backdrop-blur-sm border-2 border-white/20 rounded-full" data-id="element-1367">
                <div className="w-5 h-5 border-2 border-amber border-t-transparent rounded-full animate-spin" data-id="element-1368"></div>
                <span className="text-white font-semibold" data-id="element-1369">
                  Redirecting to Home...
                </span>
              </div>
            </div>}
        </div>
      </div>

      <footer className="bg-navy/50 border-t-2 border-white/10" data-id="element-1370">
        <div className="max-w-7xl mx-auto px-4 py-4 md:py-6" data-id="element-1371">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3" data-id="element-1372">
            <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-6 md:h-8" data-id="element-1373" />
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-blue-200" data-id="element-1374">
              <button onClick={() => navigate('/')} className="hover:text-white transition-colors" data-id="element-1375">
                Home
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}